module.exports = __webpack_public_path__ + "media/images/custom_page/younite_event5/younite-event-ja-0140e9ec4a09b323f287148e2775ec2a.png";